import PropTypes from 'prop-types';
import React from 'react';
import './progressBarStyle.scss';

const Filler = (props) => {
    return <div className="pb-filler" style={{ width: `${props.percentage}%` }} />;
};

Filler.propTypes = {
    percentage: PropTypes.number,
};

const ProgressBar = (props) => {
    return (
        <div className="pb-progress-bar" style={{ display: props.percentage > -1 ? 'inline-block' : 'none' }}>
            <Filler percentage={props.percentage} />
            <span>{props.percentage} %</span>
        </div>
    );
};

ProgressBar.propTypes = {
    percentage: PropTypes.number,
};

export default ProgressBar;
